import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/logo/iknowa-logo-v4.svg'
import _imports_1 from '../../../assets/icons/tick.svg'


const _withScopeId = n => (_pushScopeId("data-v-1f803344"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth_wrapper" }
const _hoisted_2 = { class: "form-container-default left-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "open-logo",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "form_wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "logo-description default-text mb-10" }, "Reset Password")
], -1))
const _hoisted_6 = { class: "benefit_wrapper llg:!tw-mb-[20px]" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Take a look at all the amazing benefits iknowa offers", -1))
const _hoisted_9 = { class: "right_block" }
const _hoisted_10 = { class: "right_block_content" }
const _hoisted_11 = { class: "inner-content" }
const _hoisted_12 = { class: "login_img" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "login_content" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "description" }
const _hoisted_17 = { class: "benifit_points" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_1
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChangePasswordForm = _resolveComponent("ChangePasswordForm")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_AuthIknowaInfoMobileModal = _resolveComponent("AuthIknowaInfoMobileModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-container-main", { mobileView: $setup.isShowAuthIknowaInfoMobile && $setup.isMoblieView }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_ChangePasswordForm),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h6", null, [
                _createVNode(_component_v_icon, { icon: "mdi-star" }),
                _createTextVNode("iknowa Benefits")
              ])
            ]),
            _hoisted_8,
            _createElementVNode("label", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openOverview && $setup.openOverview(...args))),
              class: "yellow-text"
            }, [
              _createTextVNode("Open iknowa Overview "),
              _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_carousel, {
          "indicator-position": "outside",
          autoplay: false,
          arrow: "never",
          class: "",
          trigger: "click"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.carouselItem, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: index,
                class: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("img", {
                          class: "open-logo",
                          src: require(`../../../assets/images/${item?.image}.png`)
                        }, null, 8, _hoisted_13)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("h2", _hoisted_15, _toDisplayString(item?.title), 1),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(item?.description), 1),
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(item?.benefits), (desc, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "benifit_points_list",
                              key: i
                            }, [
                              _hoisted_18,
                              _createElementVNode("p", null, _toDisplayString(item?.benefits[desc]), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      ($setup.isShowAuthIknowaInfoMobile)
        ? (_openBlock(), _createBlock(_component_AuthIknowaInfoMobileModal, {
            key: 0,
            onOnCloseButtonClick: $setup.onCloseButtonClick
          }, null, 8, ["onOnCloseButtonClick"]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}